<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Principal Desk" :links="[{title:'Home', url:'/'},{title:'Principal Desk'}]"></page-header>
      <section class="section">
        <div class="container1">
          <div class="flex flex-col items-center justify-center">
            <img :src="require(`@/assets/img/about/principal.jpg`)" class="mt-5 mb-5 object-fill shadow-xl">
            <h4 class="text-2xl text-gray-600 font-medium">Dr. P. M. Patil</h4>
            <h5 class="text-gray-500 font-medium">Principal, SND College of Engineering & Research Centre</h5>
          </div>
          <blockquote class="mt-10 about-message">
            <p>We welcome you to SND, to an intensified time of informed quest.</p>

            <p>We at SND believe that the path to success lies in accepting challenge as opportunities for growth. Our
              institution inculcates the journey of hard work and diligence amongst its students enabling them to
              overcome obstacles in the journey of their future lives with dignity and poise. The essential quality
              developed in an engineering graduate at SND is to possess the ability for effective problem-solving.</p>

            <p>Also, the softer but crucial aspects of engineering are “character” or “attitude” building. Development
            mind-set for holistic, systemic thinking and recognizing skills for administration; all these in addition to
            the conventional inputs towards development of analytic, rational skills. Recognizing the primary
            accountability of an adult student for learning, and day-to-day problems each students is mentored by a
            Teacher Guardian and the institution has a full-fledged Dean of Academic Affairs.</p>

            <p>As a young Institution we have miles to go. A new workshop and Hostel complex is coming up in the College
            Campus itself along with indoor and outdoor facilities for sport and games. I am also proud of the great
            team we have in the institute. In the short span time SND COE & RC has strived not only to give the best
            engineering education to our students under some of the most erudite and well-respected faculty, but also to
            integrate their knowledge in excellently equipped laboratories, through individual project, and by sending
            them out for interactive field work in industries during their higher semesters. The academic
            professionalism the members of faculty demonstrate is remarkable.</p>

            <p>I sincerely look forward to the day we meet.</p>
            <signature name="Dr. P. M. Patil" designation="Principal, SNDCOE"></signature>
          </blockquote>
        </div>
      </section>
      <programmes></programmes>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "../../components/Navbar.vue";
import FooterComponent from "../../components/Footer.vue";
import PageHeader from "../../components/PageHeader";
import Programmes from "@/views/about/Programmes";
import Signature from "@/components/Signature";

export default {
  name: "landing-page",
  components: {
    Programmes,
    NavbarComponent,
    PageHeader,
    FooterComponent,
    Signature
  },

}
</script>
<style lang="scss" scoped>
</style>
